module.exports = __webpack_public_path__ + "assets/img/goods.5bc1ceb0.svg";